import React from 'react'
import Client_Listing from '../features/client-details/client-listing/ClientListing'

export default function ClientListing() {
  return (
    <Client_Listing/>
)
}
